import { render, staticRenderFns } from "./UpdatePrice.vue?vue&type=template&id=5156861e"
import script from "./UpdatePrice.vue?vue&type=script&lang=js"
export * from "./UpdatePrice.vue?vue&type=script&lang=js"
import style0 from "./UpdatePrice.vue?vue&type=style&index=0&id=5156861e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports